import {useStyles} from '../../../../../shared/hooks/styles';
import {Theme} from '../../../../../shared/theme/interface';

const borderRadius = 5;

export default (theme: Theme) =>
  useStyles(({addShadow}) => ({
    newsCard: {
      ...addShadow({
        height: 2,
        radius: 18,
        opacity: 0.25,
      }),
      cursor: 'pointer',
      height: 188,
      backgroundColor: theme.color.backgroundMenuColor,
      marginBottom: 30,
      flexDirection: 'row',
      borderRadius: borderRadius,
    },
    pressedCard: {
      ...addShadow({
        height: 16,
        opacity: 0.1,
        radius: 20,
        width: 0,
        color: 'black',
      }),
    },
    newsImage: {
      borderTopLeftRadius: borderRadius,
      borderBottomLeftRadius: borderRadius,
      width: 315,
    },
    newsText: {
      padding: 20,
      flexShrink: 1,
    },
  }));
